<template>
  <div class="padding-five-lr" style="background: #f8f8f8">
    <b-row style="max-width: 100%" class="padding-ten-tb">
      <b-col cols="12">
        <h5 class="color-gray">{{ pageTitle }}</h5>
      </b-col>
    </b-row>

    <LiquidacionesBackoffice />
  </div>
</template>

<script>
import LiquidacionesBackoffice from "./LiquidacionesBackoffice.vue";
import { MESSAGES } from "@/services/gestor-centralizado/gestor-centralizado.constants";
import { isProveedor } from "@/constants/perfiles";
import { mapState } from "vuex";

import "@/styles/gestor-centralizado/gestor-centralizado.css";

export default {
  name: "LiquidacionesBackofficeView",

  components: {
    LiquidacionesBackoffice,
  },

  computed: {
    ...mapState("module", ["perfil"]),
    pageTitle() {
      return MESSAGES.TAB_BACKOFFICE;
    },
  },

  mounted() {
    if (isProveedor(this.perfil)) {
      this.$router.replace({ name: "BlockedPage" });
    }
  },
};
</script>
